import { Link } from "react-router-dom";
import cover from "../../assets/cover.png";
import Services from "./Services";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import { CONTACT_INFO, HERO_STATS } from "../utils/constants";
import { IconWhatsapp } from "../utils/icons";
import useDocumentMeta from "../utils/useDocumentMeta";

const Body = () => {
  useDocumentMeta(
    "PVM Consultants | Manoj Kumar — Financial Consultant, Ghaziabad",
    "20+ years managing investments, insurance, tax filing and loans for working professionals. Personal, full-service financial guidance from Manoj Kumar, PVM Consultants, Ghaziabad."
  );

  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <span className="eyebrow light">20+ Years of Trusted Guidance</span>
          <h1>
            Your Complete <span>Financial Partner</span> — For Life.
          </h1>
          <p className="hero-subtext">
            Investments, insurance, tax filing, loans and portfolio management —
            managed personally by Manoj Kumar, so working professionals like you
            never have to juggle five different people for your money.
          </p>

          <div className="hero-ctas">
            <Link to="/contact" className="btn btn-primary">
              Book a Free Consultation
            </Link>
            <a
              className="btn btn-outline"
              href={CONTACT_INFO.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconWhatsapp size={20} /> Chat on WhatsApp
            </a>
          </div>

          <div className="hero-stats">
            {HERO_STATS.map((stat) => (
              <div className="hero-stat" key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-visual">
          <img src={cover} alt="Financial consultant with briefcase" />
        </div>
      </section>

      <section className="why-choose">
        <div className="section-heading">
          <span className="eyebrow">Why Choose Manoj Kumar</span>
          <h2>One Person. Your Whole Financial Life.</h2>
        </div>
        <p className="why-choose-text">
          Most people juggle a different advisor for every part of their money —
          one for taxes, another for insurance, someone else for stock trading —
          with no one keeping track of the full picture. Manoj manages your
          entire financial life personally, so you always have a single,
          dependable person who truly knows your portfolio and has your back.
        </p>
      </section>

      <Services />
      <Testimonials />
      <FAQ />

      <section className="cta-banner">
        <div>
          <h2>Ready to put your finances on autopilot?</h2>
          <p>Get a free, no-obligation consultation and see where you stand.</p>
        </div>
        <div className="cta-banner-actions">
          <a className="btn btn-light" href={CONTACT_INFO.callLink}>
            Call {CONTACT_INFO.phoneDisplay}
          </a>
          <Link to="/contact" className="btn btn-primary">
            Get In Touch
          </Link>
        </div>
      </section>
    </>
  );
};

export default Body;
